<template>
	<div class="game-list" :class="`game-list--columns-${calcCols}`">
		<template v-if="games.length > 0">
			<transition-group name="game-list-filter" tag="div" class="game-list__items grid grid--s40--desk">
				<div class="game-list__item grid__item" :class="gridItemClass" v-for="(game, i) in games" :key="game.id">

					<info-tooltip v-if="!hasPermission" title="Login to view" ref="tooltip" :visible-on-hover="true" :visible-on-load="false" @click.native.stop>
						<p>In order to view this game, you need to be logged into an account.</p>
						<p>
							<router-link :to="{ name: 'Login' }" class="clickable link--underlined">
								<span>Login</span>
							</router-link>
							or
							<a class="link--underlined" href="mailto:ilotteryshowcaseinquiry@igt.com?subject=IGT Lottery Showcase - Request Account">Inquire about an account</a>
						</p>
					</info-tooltip>

					<div class="game-list__overview-wrapper" @click="setActiveGame(game, i)">
						<game-overview class="game-list__overview" v-bind:class="{
							'game-list__overview--active' : activeGame && game.id == activeGame,
							'game-list__overview--inactive' : activeGame && game.id != activeGame
						}" ref="gameOverview" :game="game" />
					</div>

					<div v-if="hasPermission" class="game-list__detail-wrapper" v-bind:class="{
						'game-list__detail-wrapper--active' : activeGame && game.id == activeGame
					}">
						<game-detail id="game-detail" v-if="activeGame && game.id == activeGame" ref="gameDetail" class="game-list__detail" :game="game" @close-game-detail="unsetActiveGame(game)" />
					</div>
				</div>
			</transition-group>
		</template>
		<div v-else class="game-list__empty-message">
			<slot name="empty-message">
				No games available
			</slot>
		</div>
	</div>
</template>

<script>
import { has, assign } from 'lodash'
import InfoTooltip from '../molecules/InfoTooltip'
import GameOverview from '../molecules/GameOverview'
import GameDetail from '../organisms/GameDetail'

export default {
	name: 'GameList',
	components: {
		InfoTooltip,
		GameOverview,
		GameDetail
	},
	data () {
		return {
			internalActiveGameId: null,
		}
	},
	props: {
		games: Array,
		activeGameId: [Number, String],
		activeTab: String,
		columns: Number,
	},
	computed: {
		activeGame: function()
		{
			var self = this;
			return self.internalActiveGameId || self.activeGameId;
		},
		hasPermission: function()
		{
			var self = this;
			return self.$root.userHasPermission({
				'igt': ['AM', 'CM', 'SA'],
				'operator': ['affiliate', 'customer', 'performance'],
				'guest': ['guest'],
			});
		},
		calcCols: function()
		{
			var col = typeof this.columns == 'number' ? this.columns : null;
			if(!col)
			{
				switch(this.$mq)
				{
					case 'desk':
						col = 4;
						break;
					case 'ltab':
						col = 3;
						break;
					default:
						col = 2;
						break;
				}
			}

			return col;
		},
		gridItemClass: function()
		{
			switch(this.calcCols)
			{
				case 4:
					return 'one-quarter';
				case 3:
					return 'one-third';
				case 2:
					return 'one-half';
			}

			// <attr class="one-half one-third one-quarter" />
		}
	},
	watch: {
		activeGameId: function(to, from)
		{
			var self = this;
			if(to) { self.scrollToActiveGame(); }
		},
		games: function(to, from)
		{
			var self = this;
			if(to && to.length) {	self.scrollToActiveGame(); }
		},
	},
	created: function()
	{
	},
	mounted: function()
	{
		var self = this;
		self.scrollToActiveGame();
	},
	methods: {
		setActiveGame(game, gameIndex, scrollDuration)
		{
			var self = this;

			if(!self.hasPermission)
			{
				self.$refs.tooltip[gameIndex].isVisible = true;
			}
			else
			{
				if(self.$route.name === 'Games')
				{
					self.$router.push({
						name: self.$route.name,
						params: {
							activeGameId: game.id,
							activeTab: undefined
						},
					});
				}
				else
				{
					self.internalActiveGameId = game.id

					if(self.$mq === 'ltab' || self.$mq === 'desk')
					{
						self.$nextTick(() => {
							self.scrollToActiveGame();
						});
					}
				}
			}
		},
		unsetActiveGame(game, scrollDuration)
		{
			var self = this;

			game = typeof game !== 'undefined' ? game : null;
			scrollDuration = typeof scrollDuration !== 'undefined' ? scrollDuration : 500;

			if(self.$route.name === 'Games' && has(self.$route, 'params.activeGameId') && self.$route.params.activeGameId)
			{
				self.$router.push({
					name: self.$route.name,
					params: {
						activeGameId: undefined,
						activeTab: undefined
					}
				});
			}
			else
			{
				self.internalActiveGameId = null
			}

			if((self.$mq === 'ltab' || self.$mq === 'desk') && game)
			{
				self.$nextTick(() => {
					for(var i=0; i < self.$refs.gameOverview.length; i++)
					{
						if(self.$refs.gameOverview[i].game.id === game.id)
						{
							var element = self.$refs.gameOverview[i].$el;
							self.$scrollTo(element, scrollDuration, {
								// HEADER ISN'T STICKY ANYMORE
							  // offset: -self.$root.$data.headerHeight,
							  offset: -1 * parseInt(window.getComputedStyle(element.parentElement.parentElement).marginBottom),
							});
							break;
						}
					}
				});
			}
		},
		scrollToActiveGame(scrollDuration)
		{
			var self = this;

			scrollDuration = typeof scrollDuration !== 'undefined' ? scrollDuration : 500;

			if(self.$mq === 'ltab' || self.$mq === 'desk')
			{
				self.$nextTick(() => {
					if(self.$refs)
					{
						var element = self.$refs.gameDetail;
						if(Array.isArray(element) && element.length > 0)
						{
							element = element[0].$el;
							self.$scrollTo(element, scrollDuration, {
								// HEADER ISN'T STICKY ANYMORE
							  // offset: -self.$root.$data.headerHeight,
							});
						}
					}
				});
			}
		},
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-list";
	#{$c}
	{
		// Transitions --------------

		@include media(not-phab)
		{
			&__item
			{
				transition: all 1s;
			}

			.game-list-filter-enter, .game-list-filter-leave-to
			{
				opacity: 0;
			}

			.game-list-filter-leave-active {
				position: absolute;
				transition: transform 0.95s, opacity 0.4s;
			}
		}


		// Styles ------

		&__overview
		{
			position: relative;
			z-index: 1;
			cursor: pointer;
			box-shadow: 0 0 0 rem(0) palette(blue);
			@include css-variables
			{
				transition: box-shadow calc(1s * #{var(base-trans-speed)});
			}

			&:after
			{
				content: "";
				position: absolute;
				top: 100%;
				left: 50%;
				display: block;
				width: 0;
				height: 0;
				border-width: 0px 0px 0px 0px;
				border-style: solid;
				border-color: palette(blue) transparent transparent transparent;
				transform: translateX(0) translateY(0px);

				@include css-variables
				{
					transition: transform calc(1s * #{var(base-trans-speed)}), border-width calc(1s * #{var(base-trans-speed)});
				}
			}

			&--active
			{
				box-shadow: 0 0 0 rem(4) palette(blue);
				margin-bottom: 4px;
				z-index: 20;

				&:after
				{
					border-width: 8px 8px 0px 8px;
					transform: translateX(-8px) translateY(4px);
				}
			}

			&--inactive
			{
				.game-overview__body:after
				{
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: rgba(0,0,0,0.4);
					z-index: 30;
				}
			}
		}

		&__detail-wrapper
		{
			@include media(phab)
			{
				position: fixed;
				width: 100%;
				height: 100%;
				left: 0;
				bottom: 0;
				z-index: 2000;
				transform: translateY(100%);
				background-color: palette(lightest-grey);
				overflow-y: scroll;
				-webkit-overflow-scrolling: touch;

				&--active
				{
					transform: translateY(0);

					@include css-variables
					{
						transition: transform calc(1s * #{var(base-trans-speed)});
					}
				}
			}

			@include media(not-phab)
			{
				position: relative;
				z-index: 10;

				@include css-variables
				{
					left: calc(-1px * #{$grid-gutter});
					padding-left: calc(1px * #{$grid-gutter});
				}

				@if(not $output-css-var)
				{
					@each $reduction in $grid-gutter-reduce
					{
						$name: nth($reduction, 1);
						$size: nth($reduction, 2);

						@include media($name)
						{
							left: calc(-1px * #{$size});
							padding-left: calc(1px * #{$size});
						}
					}
				}

				#{$c}--columns-3 &
				{
					@include css-variables
					{
						width: calc(3 * (100% + (1px * #{$grid-gutter})));
					}

					@if(not $output-css-var)
					{
						@each $reduction in $grid-gutter-reduce
						{
							$name: nth($reduction, 1);
							$size: nth($reduction, 2);

							@include media($name)
							{
								width: calc(3 * (100% + (1px * #{$size})));
							}
						}
					}
				}

				#{$c}--columns-3 :nth-child(3n+2) > & { transform: translateX(-33.3333%); }
				#{$c}--columns-3 :nth-child(3n+3) > & { transform: translateX(-66.6666%); }

				#{$c}--columns-4 &
				{
					@include css-variables
					{
						width: calc(4 * (100% + (1px * #{$grid-gutter})));
					}

					@if(not $output-css-var)
					{
						@each $reduction in $grid-gutter-reduce
						{
							$name: nth($reduction, 1);
							$size: nth($reduction, 2);

							@include media($name)
							{
								width: calc(4 * (100% + (1px * #{$size})));
							}
						}
					}
				}

				#{$c}--columns-4 :nth-child(4n+2) > & { transform: translateX(-25%); }
				#{$c}--columns-4 :nth-child(4n+3) > & { transform: translateX(-50%); }
				#{$c}--columns-4 :nth-child(4n+4) > & { transform: translateX(-75%); }
			}
		}

		&__detail
		{
			@include media(not-phab)
			{
				position: relative;
				width: 100vw;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/GameList.vue